import { USERS_SHOW, USER_EDIT, USERS_REQUEST, USERS_FAIL, USER_ROLE, USER_AGENCIES, USER_COMPLETE, USER_CLEAR, USER_SET_SEARCH } from "../store/config";

const usersInit = {
	isFetching: false,
	list: [],
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q: '',
		role_id: '',
		status_id: ''
	},
	edit: {
		roles: []
	},
	agencies: [],
	permissions:[],
	search: undefined,
	error: null,
	timestamp: null
}

const users = (state = usersInit, action) => {
	switch (action.type){
		case USERS_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case USERS_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		case USER_SET_SEARCH:
			return {
				...state,
				search: action.payload,
				timestamp: action.timestamp
			}
		case USERS_SHOW:
			return{
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				pages: {
					...state.pages,
					...action.pages
				},
				permissions: action.permissions,
				timestamp:action.timestamp
			}
		case USER_EDIT:
			return{
				...state,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case USER_ROLE:
			return {
				...state,
				edit: {
					...state.edit,
					...action.payload
				},
				timestamp: action.timestamp
			}
		case USER_AGENCIES:
			return {
				...state,
				agencies: action.payload,
				timestamp: action.timestamp
			}
		case USER_COMPLETE:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case USER_CLEAR:
			return {
				...state,
				edit: action.payload,
				agencies: action.payload,
				permissions: action.permissions,
				timestamp: action.payload
			}
		default:
			return{
				...state
			}
	}
}

export default users;



// WEBPACK FOOTER //
// ./src/reducers/users.js